import React, { Component } from 'react';
import HelpIcon from '@material-ui/icons/Help';
import Button from '@material-ui/core/Button';
import withToolTip from '../../../hocs/withToolTip';
import RuleItem from './RuleItem';
import TextField from '@material-ui/core/TextField';
import { bool, func, number, arrayOf, shape, string } from 'prop-types';

import styles from './styles.scss';

const IconWithToolTip = withToolTip(HelpIcon);
const tooltipTitle = {
  defaultTimespan:
    'Set a default attribute timespan for this advertiser. The data will be recalculated if changed.',
  customTimespan:
    'Use a custom time range to override the default attribution timespan. The data will be recalculated if changed.'
};

export default class Rules extends Component {
  static propTypes = {
    isDisable: bool,
    listRules: arrayOf(
      shape({
        check: bool,
        checkCompare: bool,
        value: number,
        start: string,
        end: string
      })
    ),
    onAddItem: func,
    onChangeDefaultValue: func,
    onChangeEndTime: func,
    onChangeStartTime: func,
    defaultValue: number,
    onRemoveItem: func,
    onChangeValue: func,
    appConfigRules: bool,
    inAdvertiserTab: bool,
    showCustomTitle: bool,
    nonSettingsPageTitle: string,
    nonSettingsPageSubtitle: string,
    attributionWindowTitle: string,
    disabledDefaultTitle: string,
    disabledDefaultSubtitle: string
  };

  static defaultProps = {
    nonSettingsPageTitle: 'Custom Attribution Timespan',
    nonSettingsPageSubtitle: 'These settings are enforced by your admin and cannot be adjusted.',
    attributionWindowTitle: 'Default attribution window',
    disabledDefaultTitle: 'Set the timespan',
    disabledDefaultSubtitle: 'The timespan determines how ad visits are accounted.'
  };

  handleChangeDefaultValue = event => {
    const { onChangeDefaultValue } = this.props;
    event.preventDefault();

    let value = parseInt(event.target.value);
    // Clamp value within the range [1, 60]
    value = Math.max(1, Math.min(60, value));
    onChangeDefaultValue && onChangeDefaultValue(value);
    // Update the input field to reflect the clamped value
    event.target.value = value;
  };
  // triggered when the input loses focus, purpose re-validate and set default value.
  handleTimespanInputBlur = event => {
    // user clear input or any NaN value, it should set a default value 8
    let value = parseInt(event.target.value) || 8;
    value = Math.max(1, Math.min(60, value));
    const { onChangeDefaultValue } = this.props;

    onChangeDefaultValue && onChangeDefaultValue(value);
    // Update the input field to reflect the clamped value
    event.target.value = value;
  };

  render() {
    const {
      isDisable,
      listRules,
      onAddItem,
      onChangeEndTime,
      onChangeStartTime,
      onRemoveItem,
      onChangeValue,
      defaultValue,
      appConfigRules,
      inAdvertiserTab,
      showCustomTitle,
      nonSettingsPageSubtitle,
      nonSettingsPageTitle,
      attributionWindowTitle,
      disabledDefaultSubtitle,
      disabledDefaultTitle
    } = this.props;

    const titleStyle = isDisable ? styles.ruleDetailTitle : styles.ruleDetailTitleDisabled;

    return (
      <div className={inAdvertiserTab ? styles.rule : ''}>
        {!appConfigRules && (
          <h2 className={styles.ruleTitle}>{nonSettingsPageTitle}</h2>
        )}
        <div className={inAdvertiserTab ? styles.ruleDetail : ''}>
          {isDisable && (
            <div>
              <h2 className={styles.ruleTitle}>{nonSettingsPageSubtitle}</h2>
            </div>
          )}
          {!isDisable &&
            !appConfigRules && (
              <div>
                <p className={styles.ruleTitle}>{disabledDefaultTitle}</p>
                <p className={styles.ruleDescription}>{disabledDefaultSubtitle}</p>
              </div>
            )}
          <div className={styles.listHeader}>
            <div className={titleStyle}>
              {appConfigRules && attributionWindowTitle}
              {inAdvertiserTab && (
                <div>
                  <p className={styles.ruleDetailTitle}>Default timespan</p>
                  <div className={styles.iconTimespan}>
                    <IconWithToolTip
                      tooltip={{
                        text: tooltipTitle.defaultTimespan,
                        style: styles.tooltipDefaultTime,
                        placement: 'top'
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div>
              <TextField
                type="number"
                value={defaultValue}
                className={styles.inputDate}
                inputProps={{ min: 1, max: 60, step: 1 }} // Optional, for spin button behavior
                disabled={isDisable}
                onChange={this.handleChangeDefaultValue}
                onBlur={this.handleTimespanInputBlur}
              />
            </div>
            <div>
              <span>Minutes</span>
            </div>
          </div>

          {!appConfigRules && ((showCustomTitle && isDisable) || !isDisable) && (
            <div className={styles.listHeader}>
              <div
                className={titleStyle}>
                <p className={styles.ruleDetailTitle}>Custom timespan</p>
                <div className={styles.iconTimespan}>
                  <IconWithToolTip
                    tooltip={{
                      text: tooltipTitle.customTimespan,
                      style: styles.tooltipCustomTime,
                      placement: 'top'
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          <div className={inAdvertiserTab ? styles.list : styles.ruleListContainer}>
            {listRules &&
              listRules.map((rule, index) => (
                <RuleItem
                  inAdvertiserTab={inAdvertiserTab}
                  appConfigRules={appConfigRules}
                  rule={rule}
                  index={index}
                  key={index}
                  onChangeStartTime={onChangeStartTime}
                  onChangeEndTime={onChangeEndTime}
                  onRemoveItem={onRemoveItem}
                  isDisable={isDisable}
                  onChangeValue={onChangeValue}
                />
              ))}
          </div>
        </div>
        <div>
          {!isDisable && (
            <Button
              variant="outlined"
              color="primary"
              data-veritone-element="button-add-custom-rule"
              onClick={onAddItem}
            >
              Add Custom
            </Button>
          )}
        </div>
      </div>
    );
  }
}
